var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-container", [
    _vm.isRequestingUserData
      ? _c(
          "div",
          [
            _c("spinner-loader", {
              attrs: { loading: _vm.isRequestingUserData },
            }),
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "b-jumbotron",
              {
                staticClass: "profile-header mb-2",
                staticStyle: {
                  "background-image":
                    "url(https://source.unsplash.com/h2Uf8Kd6MN0)",
                  "background-size": "cover",
                },
                attrs: { "img-alt": "Image", "img-right": "" },
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "editButton",
                    attrs: { variant: "primary" },
                    on: { click: _vm.editOrSubmit },
                  },
                  [_vm._v(_vm._s(_vm.editButtonText))]
                ),
                _vm._v(" "),
                _c("picture-placeholder", {
                  attrs: {
                    textIn:
                      _vm.formData.first_name + " " + _vm.formData.last_name,
                    pictureUrl: _vm.formData.photo_uri,
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isEditing
              ? _c("div", { staticClass: "user-account-info" }, [
                  _c("div", { staticClass: "user-account-name" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.formData.first_name + " " + _vm.formData.last_name
                        ) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.formData.sex
                    ? _c("span", [
                        "MALE" == _vm.formData.sex.toUpperCase()
                          ? _c("span", [_vm._v("♂")])
                          : "FEMALE" == _vm.formData.sex.toUpperCase()
                          ? _c("span", [_vm._v("♀")])
                          : _c("span", [_vm._v("⚦⚲")]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formData.birthday
                    ? _c("span", [
                        _vm._v(" 🎂" + _vm._s(_vm.formData.birthday) + " "),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("p", { staticClass: "card-text" }, [
                    _vm._v("Premium Member since 2019"),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("b-form", { on: { submit: _vm.handleSubmit } }, [
              _vm.isEditing
                ? _c(
                    "div",
                    { staticClass: "edit-account-form" },
                    [
                      _c(
                        "b-row",
                        { staticClass: "account-full-name" },
                        [
                          _c(
                            "b-col",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "first_name",
                                  type: "text",
                                  placeholder: "first",
                                },
                                model: {
                                  value: _vm.formData.first_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "first_name", $$v)
                                  },
                                  expression: "formData.first_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "middleNameInput",
                                  type: "text",
                                  placeholder: "middle",
                                },
                                model: {
                                  value: _vm.formData.middle_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "middle_name", $$v)
                                  },
                                  expression: "formData.middle_name",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { size: "sm" } },
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "last_name",
                                  type: "text",
                                  placeholder: "last",
                                },
                                model: {
                                  value: _vm.formData.last_name,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "last_name", $$v)
                                  },
                                  expression: "formData.last_name",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-radio-group",
                                {
                                  model: {
                                    value: _vm.formData.sex,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "sex", $$v)
                                    },
                                    expression: "formData.sex",
                                  },
                                },
                                [
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: "male" } },
                                    [_vm._v("♂ Male")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: "female" } },
                                    [_vm._v("♀ Female")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-form-radio",
                                    { attrs: { value: "unknown" } },
                                    [_vm._v("⚦⚲ Decline")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { attrs: { size: "small" } },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "input-group birthday-row",
                              attrs: { cols: "6", size: "sm" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "input-group-prepend" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "input-group-text" },
                                    [_vm._v("🎂")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("b-form-input", {
                                attrs: { id: "birthdayInput", type: "date" },
                                model: {
                                  value: _vm.formData.birthday,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "birthday", $$v)
                                  },
                                  expression: "formData.birthday",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "b-card-group",
              {
                staticClass: "mb-4",
                staticStyle: {
                  "margin-top": "75px",
                  "padding-top": "16px",
                  "column-count": "2",
                },
                attrs: { columns: "", deck: "" },
              },
              [
                _c(
                  "b-card",
                  {
                    staticClass: "mb-2",
                    staticStyle: { "max-width": "24rem" },
                    attrs: { title: "About Me" },
                  },
                  [
                    !_vm.isEditing
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formData.citizenship) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formData.country) +
                              "\n        "
                          ),
                        ])
                      : _c(
                          "div",
                          { staticClass: "social-form" },
                          [
                            _c("i", { staticClass: "fi-compass" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "citizenshipInput",
                                type: "text",
                                placeholder: "citizenship",
                              },
                              model: {
                                value: _vm.formData.citizenship,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "citizenship", $$v)
                                },
                                expression: "formData.citizenship",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-home" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "countryInput",
                                type: "text",
                                placeholder: "home country",
                              },
                              model: {
                                value: _vm.formData.country,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "country", $$v)
                                },
                                expression: "formData.country",
                              },
                            }),
                          ],
                          1
                        ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  {
                    staticClass: "mb-2",
                    staticStyle: { "max-width": "24rem" },
                    attrs: { title: "Contact" },
                  },
                  [
                    !_vm.isEditing
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formData.email) +
                              "\n          "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.formData.address) +
                              "\n        "
                          ),
                        ])
                      : _c(
                          "div",
                          { staticClass: "social-form" },
                          [
                            _c("i", { staticClass: "fi-map" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "addressInput",
                                type: "text",
                                placeholder: "address",
                              },
                              model: {
                                value: _vm.formData.address,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "address", $$v)
                                },
                                expression: "formData.address",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-mail" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: {
                                id: "email",
                                type: "email",
                                placeholder: "email",
                              },
                              model: {
                                value: _vm.formData.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "email", $$v)
                                },
                                expression: "formData.email",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-telephone" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "phoneInput", type: "tel" },
                              model: {
                                value: _vm.formData.phone,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "phone", $$v)
                                },
                                expression: "formData.phone",
                              },
                            }),
                          ],
                          1
                        ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-card",
                  {
                    staticClass: "mb-2",
                    staticStyle: { "max-width": "24rem" },
                    attrs: { title: "Social" },
                  },
                  [
                    !_vm.isEditing
                      ? _c("div", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.formData.facebook,
                                target: "_blank",
                              },
                            },
                            [
                              null != _vm.formData.facebook
                                ? _c("i", { staticClass: "fi-social-facebook" })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.formData.instagram,
                                target: "_blank",
                              },
                            },
                            [
                              null != _vm.formData.instagram
                                ? _c("i", {
                                    staticClass: "fi-social-instagram",
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.formData.twitter,
                                target: "_blank",
                              },
                            },
                            [
                              null != _vm.formData.twitter
                                ? _c("i", { staticClass: "fi-social-twitter" })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.formData.pinterest,
                                target: "_blank",
                              },
                            },
                            [
                              null != _vm.formData.pinterest
                                ? _c("i", {
                                    staticClass: "fi-social-pinterest",
                                  })
                                : _vm._e(),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.formData.snapchat,
                                target: "_blank",
                              },
                            },
                            [
                              null != _vm.formData.snapchat
                                ? _c("i", { staticClass: "fi-social-snapchat" })
                                : _vm._e(),
                            ]
                          ),
                        ])
                      : _c(
                          "div",
                          { staticClass: "social-form" },
                          [
                            _c("i", { staticClass: "fi-social-facebook" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "facebookInput", type: "url" },
                              model: {
                                value: _vm.formData.facebook,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "facebook", $$v)
                                },
                                expression: "formData.facebook",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-social-instagram" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "instagramInput", type: "url" },
                              model: {
                                value: _vm.formData.instagram,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "instagram", $$v)
                                },
                                expression: "formData.instagram",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-social-twitter" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "twitterInput", type: "url" },
                              model: {
                                value: _vm.formData.twitter,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "twitter", $$v)
                                },
                                expression: "formData.twitter",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-social-pinterest" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "pinterestInput", type: "url" },
                              model: {
                                value: _vm.formData.pinterest,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "pinterest", $$v)
                                },
                                expression: "formData.pinterest",
                              },
                            }),
                            _vm._v(" "),
                            _c("i", { staticClass: "fi-social-snapchat" }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              attrs: { id: "snapchatInput", type: "url" },
                              model: {
                                value: _vm.formData.snapchat,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "snapchat", $$v)
                                },
                                expression: "formData.snapchat",
                              },
                            }),
                          ],
                          1
                        ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isUpdatingUser
              ? _c(
                  "div",
                  [
                    _c("spinner-loader", {
                      attrs: { loading: _vm.isUpdatingUser },
                    }),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "b-button",
                      {
                        ref: "submitBtn",
                        attrs: {
                          id: "submitBtn",
                          type: "submit",
                          variant: "primary",
                        },
                        on: { click: _vm.editOrSubmit },
                      },
                      [_vm._v("Save")]
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }